import { IAppState } from '../../../AppModulesWrapper';

export function selectNextBets(state: IAppState): number[] {
  return state.servicePickerWidget.auction.nextBets;
}
